import { AppState } from '@store/app.store';
import { createSelector } from '@ngrx/store';

import { logoAdapter } from '@store/reducer/logo.reducer';

export const selectFeature = (state: AppState) => state.logo;

export const selectIsLoadingLogo = createSelector(
  selectFeature,
  state => state.isLoading
);

export const selectLogo = createSelector(
  selectFeature,
  logoAdapter.getSelectors().selectAll
);

export const selectLogoError = createSelector(
  selectFeature,
  state => state.error
);
